module.exports = __webpack_public_path__ + "static/anatomical-21d02d1846f40e19fd5c9f1deb40a84c.jpg";